import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {toInteger} from '@ng-bootstrap/ng-bootstrap/util/util';
import {StorageService} from '../../../services/rest-api/storage.service';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-microsite',
  templateUrl: './microsite.component.html',
  styleUrls: ['./microsite.component.scss']
})
export class MicrositeComponent implements OnInit {

  slidesData: any[] = [];
  deptData: any[] = [];
  newsData: any[] = [];
  studentNoticeData: any[] = [];
  newsLetterData: any[] = [];
  eventsData: any[] = [];
  headMessageData: any[] = [];
  degreeData: any[] = [];
  linksData: any[] = [];
  eventColor: string;
  public deptId: number = 0;
  private deptCode: string = "";

  dept_name: string = "";
  short_desc: string  = "";
  long_desc: string  = "";
  youtubeUrls: any[] = [];

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              private router: Router,
              private storage: StorageService,
              private seo: SeoService) {

    this._actRoute.paramMap.subscribe(params => {
      this.loadData();
    });

    this.eventColor= 'event_color';
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    this.linksData = [];
    this.deptId = Number(this._actRoute.snapshot.paramMap.get('deptid'));
    this.deptCode = String(this._actRoute.snapshot.paramMap.get('deptcode'));
    localStorage.setItem('currentDeptId', this.deptId.toString());

    // If route empty
    if(this.deptId == null){
      this.deptId = Number(localStorage.getItem('currentDeptId'));
      this.deptCode = String(localStorage.getItem('currentDeptCode'));
    }

    this.getDepartmentById(this.deptId);
    this.getActiveNews(this.deptId);
    this.getActiveEvents(this.deptId);
    this.getHeadMessages(this.deptId);
    this.getDegreesByDept(this.deptId);
    this.getLinksByDept(this.deptId);
    this.getActiveStudentNotices(this.deptId);
    this.getActiveNewsletter(this.deptId);

    this.getHomeSlider(this.deptCode);
  }

  navigatePage(current: string, param?: number) {
    if (current === 'home') {
      this.router.navigate(['/home']);

    } else if (current === 'degrees') {
      this.router.navigate(['/degrees/'+param]);

    }else if (current === 'degreedet') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['/degreedet/'],navigationExtras);

    }else if (current === 'info') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['/info/'],navigationExtras);
    }
  }

  // Get slider for home slider ID = 1
  getHomeSlider(byName: string){
    this._info.getSlidesByName(byName).subscribe (
      (response: HssResponse<any>) => {
        this.slidesData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  getDepartmentById(deptId: number){
    this._info.getDepartmentById(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.deptData = response.body;

        let urls = this.deptData[0].url;
        this.youtubeUrls = urls.split(',');

        this.seo.setMeta(this.deptData[0].dept_name, this.deptData[0].short_desc);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  setMyStyles() {
    const url = 'url('+this.deptData[0].images+')'
    let styles = {
      'background-image': url,
      'background-color': '#011c38',
      'background-repeat':'no-repeat',
    };
    return styles;
  }

  // Get News for department - News ID : 1
  getActiveNews(deptId: number){
    this._info.getActiveInfoByDept(deptId, 1).subscribe (
      (response: HssResponse<any>) => {
        this.newsData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

    // Get News for department - News ID : 1
    getActiveStudentNotices(deptId: number){
      this._info.getActiveInfoByDept(deptId, 3).subscribe (
        (response: HssResponse<any>) => {
          this.studentNoticeData = response.body;
        },
        (error: HssErrorResponse<any>) => {
          // Show the failed message
          const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
        }
      );
    }

  // Get News for department - Newsletter ID : 9
  getActiveNewsletter(deptId: number){
    this._info.getActiveInfoByDept(deptId, 9).subscribe (
      (response: HssResponse<any>) => {
        this.newsLetterData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get information for department - Events ID : 2
  getActiveEvents(deptId: number){
    this._info.getActiveInfoByDept(deptId, 2).subscribe (
      (response: HssResponse<any>) => {
        this.eventsData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get head message for department - Head mesasge ID : 8
  getHeadMessages(deptId: number){
    this._info.getActiveInfoByDept(deptId, 8).subscribe (
      (response: HssResponse<any>) => {
        this.headMessageData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // View degrees by department id
  getDegreesByDept(deptId: number){
    this._info.getDegreesByDept(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.degreeData = response.body;
        this.storage.setdata('deptDegreeData',this.degreeData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // View degrees by department id
  getLinksByDept(deptId: number){
    this.linksData = [];
    this._info.getLinksByDept(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.linksData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
